import { LocationDescriptor, createBrowserHistory } from 'history';

const history = createBrowserHistory();
const initialPushFn = history.push.bind({});
const initialReplaceFn = history.replace.bind({});

const handlePathChange = (
  initialFn: typeof initialPushFn,
  path: LocationDescriptor<unknown>,
  state: unknown,
  keepQueryParams = true,
) => {
  const parsedPath = pathToString(path);
  const pathState = typeof path === 'string' ? null : path.state;

  const { pathname, search, hash } = new URL(parsedPath, window.location.origin);

  const newPath: LocationDescriptor = {
    pathname,
    search: !search.length && keepQueryParams ? window.location.search : search,
    hash,
    // Only pass state if it exists, otherwise it will override the provided state argument with `null`
    ...(pathState ? { state: pathState } : {}),
  };

  return initialFn(newPath, state);
};

history.push = (path, state) => handlePathChange(initialPushFn, path, state);
history.replace = (path, state) => handlePathChange(initialReplaceFn, path, state);

export default history;

const pathToString = (path: LocationDescriptor): string => {
  if (typeof path === 'string') return path;

  return (path.pathname ?? '/').concat(path.search ?? '').concat(path.hash ?? '');
};
